import { useState } from "react";
import { loadStripe } from '@stripe/stripe-js';
import axios from 'axios';
import '../styles/cart.scss';
import { TextField, Alert, FormControlLabel, Checkbox, Button } from '@mui/material';
import Nav from "../Nav";

const stripe = await loadStripe('pk_live_aRr3qYrpVTbyNgBbB7t0jqiy');
// const stripe = await loadStripe("pk_test_HGDc5rMpzlE4NJvFygwF1zIW");



export default function Subscription() {
  const url = 'https://dev.pmwwebdesign.com'
  // const url = 'http://localhost:3999'
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');

  // alerts
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('');
  const [showAlert, setShowAlert] = useState(false)
  const [disabled, setDisabled] = useState(true)

  const handleTc = (value) => {
    if (value == true) {
      setDisabled(false)
    } else {
      setDisabled(false)
    }
  }


  const createSubs = async () => {
    const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/

    if (email === "" || !email.match(regex)) {
      setMessage("Please instert a valid email")
      setSeverity("warning")
      setShowAlert(true)
      setTimeout(() => {
        setShowAlert(false)
      }, 2000)
    } else if (firstName === "" || lastName === "" || phone === "") {
      setMessage("Please fill in all details")
      setSeverity("warning")
      setShowAlert(true)
      setTimeout(() => {
        setShowAlert(false)
      }, 2000)

    } else {
      let data = {
        email: email,
        firstName: firstName,
        lastName: lastName,
        phone: phone,
      }
      localStorage.setItem('ftSclient', JSON.stringify(data))
      localStorage.setItem('ptsd_subs', true)

      axios.post(`${url}/property/ft-subscription`, data)
        .then((res) => {
          console.log(res.data)
        }).catch((err) => {
          if (err.response.status == 303) {
            const redirectUrl = err.response.data.url;
            window.location.href = redirectUrl
          } else {
            setMessage("Something went wrrong, please try again")
            setSeverity("error")
            setShowAlert(true)
            setTimeout(() => {
              setShowAlert(false)
            }, 2000)

          }
        })
    }


  }
  return (
    <main className="cart">
      <Nav />
              <section className="form">
                <h2>Please Insert Your Details For Monthly Payments</h2>
                <section className="form__row">
                  <TextField id="outlined-basic" label="First Name" variant="outlined" className='field' onChange={(e) => setFirstName(e.target.value)} required />
                  <TextField id="outlined-basic" label="Last Name" variant="outlined" className='field' onChange={(e) => setLastName(e.target.value)} required />
                </section>
                <section className="form__row">
                  <TextField id="outlined-basic" label="Email" variant="outlined" className='field' onChange={(e) => setEmail(e.target.value)} required />
                  <TextField id="outlined-basic" label="Phone Number" variant="outlined" className='field' onChange={(e) => setPhone(e.target.value)} pattern='[0-9]*' required />
                </section>
                <FormControlLabel
                    control={<Checkbox />}
                    label="I confirm I have read and agree to the terms & conditions"
                    onChange={(e) => handleTc(e.target.checked)}
                  />
      
      {showAlert ? (
            <Alert severity={severity} sx={{ margin: '1% auto', width: '80%' }} variant="filled">{message}</Alert>
          ) : (
            <Button onClick={createSubs} variant="contained" color="primary" disabled={disabled}>Register</Button>
          )}
      
      </section>
    </main>

  )
}